<template>
  <span
    class="inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-semibold rounded-lg border"
    :class="badgeClasses"
  >
    <i
      class="mdi text-[13px] shrink-0 opacity-90"
      :class="iconClass"
    ></i>
    <span class="truncate">{{ label }}</span>
  </span>
</template>

<script setup>
import { computed } from "vue";
import {
  pickTranslatedName,
  statusBadgeClasses,
  statusIconClass,
  getStatusCode,
} from "@/utils/ticket";

const props = defineProps({
  status: { type: Object, default: null },
  unassigned: { type: Boolean, default: false },
  lang: { type: String, default: "ar" },
  t: { type: Function, required: true },
});

const badgeClasses = computed(() =>
  statusBadgeClasses(props.status, { unassigned: props.unassigned }),
);

const iconClass = computed(() =>
  statusIconClass(props.status, { unassigned: props.unassigned }),
);

const label = computed(() => {
  const code = getStatusCode(props.status);
  if (code === "open" && props.unassigned) {
    return props.t("ticket_status_new") || "New";
  }
  const fromApi = pickTranslatedName(props.status, props.lang);
  if (fromApi) return fromApi;
  return props.t("ticket_status_unknown") || "—";
});
</script>
